import React, { useRef } from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import SwitchInput from 'apps/auth/components/form/SwitchInput';
import Form from 'apps/auth/components/form-multi/Form';
import { PROFILE_NOTIFICATION } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_SUBSCRIBE_UPDATE } from 'apps/auth/constants/UrlConstants';

const SwitchInputNotification = (props) => {
    const submitRef = useRef(null);

    const changeHandler = () => {
        submitRef.current.click();
        props.popupRef.current?.close();
    };

    return (
        <Form formName={PROFILE_NOTIFICATION} action={AUTH_PROFILE_SUBSCRIBE_UPDATE}>
            <SwitchInput formName={PROFILE_NOTIFICATION} field={props.field} onChangeHandler={changeHandler} />
            <Button type="submit" variant={'hidden'} ref={submitRef} />
        </Form>
    );
};

export default SwitchInputNotification;
